/*!
 * hf-waitlist.js — HitchFire list capture, direct to Klaviyo.
 *
 * Posts straight to Klaviyo's public client endpoint, the same way
 * hf-persona-gate.js and hf-klaviyo-signup.js do, so the signup does not depend
 * on the Shopify -> Klaviyo sync. No Shopify customer is created: joining a list
 * is an interest signal, not an account.
 *
 * Subscribes to TWO lists, which each form's fine print discloses:
 *   the list named on the wrapper (who gets the thing being offered)
 *   QZiq2A  HitchFire  (the main marketing list)
 *
 * Markup contract — the wrapper carries the config:
 *   [data-hf-waitlist]              wrapper
 *     data-hf-list="TCDNyV"         Klaviyo list id      (default TCDNyV)
 *     data-hf-source="..."          custom_source         (default Slide-out waitlist)
 *     data-hf-label="..."           HF Waitlist property  (default Slide-Out Camp Kitchen)
 *     data-hf-key="..."             localStorage key      (default hfSlideOutWaitlist)
 *   [data-hf-waitlist-form]         the form
 *   [data-hf-waitlist-email]        the email input
 *   [data-hf-waitlist-btn]          the submit button
 *   [data-hf-waitlist-msg]          inline error text
 *   [data-hf-waitlist-done]         success panel, hidden until it succeeds
 */
(function () {
  'use strict';

  var COMPANY_ID = 'Sn3eGA';
  var REVISION = '2024-10-15';
  var ENDPOINT = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + COMPANY_ID;
  var MAIN_LIST_ID = 'QZiq2A';

  var DEFAULTS = {
    list: 'TCDNyV',
    source: 'Slide-out waitlist',
    label: 'Slide-Out Camp Kitchen',
    key: 'hfSlideOutWaitlist'
  };

  function conf(root) {
    return {
      list: root.getAttribute('data-hf-list') || DEFAULTS.list,
      source: root.getAttribute('data-hf-source') || DEFAULTS.source,
      label: root.getAttribute('data-hf-label') || DEFAULTS.label,
      key: root.getAttribute('data-hf-key') || DEFAULTS.key
    };
  }

  function valid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email);
  }

  function subscribe(email, listId, c) {
    return fetch(ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: REVISION },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: c.source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: {
                    'HF Signup Source': c.source,
                    'HF Waitlist': c.label
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    }).then(function (res) {
      if (!res.ok && res.status !== 202) throw new Error('klaviyo ' + res.status);
      return res;
    });
  }

  function remember(key, email) {
    try {
      localStorage.setItem(key, JSON.stringify({ email: email, at: Date.now() }));
    } catch (err) {}
  }

  function alreadyJoined(key) {
    try { return !!localStorage.getItem(key); } catch (err) { return false; }
  }

  function showDone(root) {
    var form = root.querySelector('[data-hf-waitlist-form]');
    var done = root.querySelector('[data-hf-waitlist-done]');
    if (form) form.style.display = 'none';
    if (done) done.removeAttribute('hidden');
  }

  function init(root) {
    var c = conf(root);
    var form = root.querySelector('[data-hf-waitlist-form]');
    var input = root.querySelector('[data-hf-waitlist-email]');
    var btn = root.querySelector('[data-hf-waitlist-btn]');
    var msg = root.querySelector('[data-hf-waitlist-msg]');
    if (!form || !input) return;

    if (alreadyJoined(c.key)) showDone(root);

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (input.value || '').trim();
      if (msg) msg.textContent = '';

      if (!valid(email)) {
        if (msg) msg.textContent = 'That email does not look right. Check it and try again.';
        input.focus();
        return;
      }

      var label = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding you...'; }

      /* The named list is the one that matters, so its result decides the UI.
         The main-list add is best effort and must never fail the signup. */
      subscribe(email, c.list, c)
        .then(function () {
          if (c.list === MAIN_LIST_ID) return;
          return subscribe(email, MAIN_LIST_ID, c).catch(function () {});
        })
        .then(function () {
          remember(c.key, email);
          showDone(root);
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'hf_waitlist_join', hf_waitlist: c.label });
          } catch (err) {}
        })
        .catch(function () {
          if (btn) { btn.disabled = false; btn.textContent = label; }
          if (msg) msg.textContent = 'That did not go through. Try again, or email sales@hitchfire.com and we will add you.';
        });
    });
  }

  function boot() {
    var roots = document.querySelectorAll('[data-hf-waitlist]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
